import { createZodDto } from "nestjs-zod/dto";
import {
  booleanOperatorSchema,
  dateOperatorSchema,
  numberOperatorSchema,
  stringOperatorSchema,
} from "./../operations/operation-filter";
import { z, ZodType } from "zod";

export const filterUserSchema = z.object({
  name: stringOperatorSchema.optional(),
  //username: stringOperatorSchema.optional(),
  email: stringOperatorSchema.optional(),
  //role:numberOperatorSchema.optional(),
  // credit:numberOperatorSchema.optional(),
  emailVerified: booleanOperatorSchema.optional(),
  isActivated: booleanOperatorSchema.optional(),
  // dateValidityCredit:dateOperatorSchema.optional(),
  createdAt: dateOperatorSchema.optional(),
  isInternal: booleanOperatorSchema.optional(),
  roleId: stringOperatorSchema.optional(), // filtre par ID de rôle
  roleName: stringOperatorSchema.optional(),
});

export type FilterUserType = z.infer<typeof filterUserSchema>;

//export class FilterUserDto extends createZodDto(filterUserSchema) {};
